import request from '@teetsh/app/src/utils/request';
import {
  deserializeCarnet,
  deserializeEDTSearchResult,
  deserializeEleve,
  deserializeSearchSeance,
  deserializeEvaluationSearchResult,
} from './serializer';
import {
  deserializeFicheDePreps,
  deserializeSequence,
} from '@teetsh/app/src/queries/sequences/serializer';
import parseISO from '@teetsh/app/src/utils/time/parseISO';
import deserializeDateFromServer from '@teetsh/app/src/utils/time/deserializeDateFromServer';
import { SearchEntityKey } from '@teetsh/app/src/containers/Search/types';
import { trackEvent } from '@teetsh/app/src/queries/user/track';

export function search({
  query,
  tz,
  filter,
}: {
  query: string;
  tz: string;
  filter?: SearchEntityKey;
}) {
  return request('/search', {
    method: 'POST',
    body: {
      query,
      filterEntity: filter,
    },
  }).then(data => {
    trackEvent('Search 🔎', {
      query,
      filter,
    });
    return {
      seances: (data?.seances || []).map(seance =>
        deserializeSearchSeance(seance, tz),
      ),
      eleves: (data?.eleves || []).map(eleve => deserializeEleve(eleve, tz)),
      carnets: (data?.carnets || []).map(carnet =>
        deserializeCarnet(carnet, tz),
      ),
      programmations: data?.programmations || [],
      notes: (data?.notes || []).map(note => ({
        ...note,
        createdAt: parseISO(note.createdAt),
      })),
      sequences: (data?.sequences || []).map(seq => deserializeSequence(seq)),
      emploisDuTemps: (data?.emploisDuTemps || []).map(edt =>
        deserializeEDTSearchResult(edt),
      ),
      reunions: (data?.reunions || []).map(reunion => ({
        ...reunion,
        date: deserializeDateFromServer(parseISO(reunion.date), tz),
      })),
      fichesDePrep: (data?.fichesDePrep || []).map(fiche =>
        deserializeFicheDePreps(fiche),
      ),
      livrets: (data?.livrets || []).map(livret => ({
        ...livret,
        createdAt: parseISO(livret.createdAt),
        periodeFrom: deserializeDateFromServer(
          parseISO(livret.periodeFrom),
          tz,
        ),
        periodeTo: deserializeDateFromServer(parseISO(livret.periodeTo), tz),
      })),
      evaluations: (data?.evaluations || []).map(ev =>
        deserializeEvaluationSearchResult(ev, tz),
      ),
      isEmpty: data.isEmpty,
    };
  });
}
